import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

const COL_WIDTHS = ["62%", "78%", "50%", "70%", "55%", "74%", "45%"];

const TableSkeleton = ({ rows = 10, columns = 5 }: TableSkeletonProps) => (
  <TableContainer component={Paper} sx={{ mt: "10px" }}>
    <Table size="small">
      <TableHead>
        <TableRow>
          {Array.from({ length: columns }).map((_, i) => (
            <TableCell key={i}>
              <Skeleton
                variant="text"
                animation="wave"
                width={COL_WIDTHS[i % COL_WIDTHS.length]}
                sx={{ fontSize: "0.875rem", transform: "none", borderRadius: "4px" }}
              />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <TableRow key={rowIndex}>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <TableCell key={colIndex}>
                <Skeleton
                  variant="text"
                  animation="wave"
                  width={COL_WIDTHS[(rowIndex + colIndex) % COL_WIDTHS.length]}
                  sx={{ fontSize: "0.875rem", transform: "none", borderRadius: "4px" }}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TableSkeleton;
